import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const SalesTargetNavUI = ({ context, account, page }) =>
    <div className='g_flex_h g_flex_left g_flex_wrap nav'>
      <TabLinkUI label='Report' to={`/su/salesTargets/report`} active={page === 'report'} />
      <TabLinkUI label='Charts' to={`/su/salesTargets/chart`} active={page === 'chart'} />
      <TabLinkUI label='Contacts' to={`/su/salesTargets/contacts`} active={page === 'contacts'} />
    </div>
  
  export default SalesTargetNavUI
  